import {Injectable} from '@angular/core';
import {CanLoad, Route, Router, UrlSegment} from '@angular/router';
import {Store} from '@ngrx/store';
import {of} from 'rxjs';
import {map, switchMap, take} from 'rxjs/operators';
import {AppState} from '../../../reducers';
import {canNavigate, getRoles} from '../../selectors/auth.selector';
import {isSupportUser} from "../../../shared/services/base-user/base-user.service";
import {CheckRoutes} from "../../../shared/enums/routes.enum";
import {ModuleNameEnum} from "../../enums/module-name.enum";

@Injectable()
export class CanLoadGuard implements CanLoad {

  constructor(
    private store: Store<AppState>,
    private router: Router
  ) {}

  canLoad(route: Route, segments: UrlSegment[]) {
    return this.store.select(canNavigate).pipe(
      take(1),
      switchMap(can => {
        if (!can) {
          if(localStorage.getItem(`isRefreshing`) !== 'true') {
            const callbackUrl = location.href;
            this.router.navigate(['/login'], { queryParams: { callbackUrl } });
          }
          return of(false);
        }

        return this.store.select(getRoles).pipe(
          take(1),
          map(roles => {
            if (isSupportUser(roles) && route.data.module === ModuleNameEnum.dashboard) {
              this.router.navigateByUrl(`/${CheckRoutes.HOME}`);
            } else if (!isSupportUser(roles) && route.data.module === CheckRoutes.HOME) {
              this.router.navigateByUrl(`/${CheckRoutes.USER}`);
            }
            return true;
          })
        );
      })
    );
  }
}
